const removeUrls = (text: string) => {
	// First remove any URLs with their surrounding parentheses
	let result = text.replace(/\(https?:\/\/[^)]+\)/g, "");

	// Then remove any remaining URLs without parentheses
	result = result.replace(/https?:\/\/[^\s]+/g, "");

	// Remove any remaining parentheses and their content
	result = result.replace(/\([^)]*\)/g, "");

	// Remove any remaining standalone parentheses
	result = result.replace(/[()]/g, "");

	// Clean up extra whitespace and trim
	result = result.replace(/\s+/g, " ").trim();

	return result;
};

const removeKnock = (text: string) => {
	return text.replace(/Powered by Knock/g, "").trim();
};

export { removeUrls, removeKnock };
